/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { getTransactionsAction } from "../actions/adminDashboardAction";

const initialState: any = {};

const getTrasactionsDataSlice = createSlice({
  name: "Guest User Transaction Data",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTransactionsAction.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getTransactionsAction.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getTransactionsAction.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default getTrasactionsDataSlice.reducer;
